import { Location } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import jsQR, { QRCode } from 'jsqr';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';

@Component({
    selector: 'app-scan',
    templateUrl: './scan.component.html',
    styleUrls: ['./scan.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScanComponent implements OnInit, AfterViewInit, OnDestroy {
    public WEBCAM_DISPLAY_WIDTH: any = window.innerWidth - 30; // 30 padding right and left 15 in the main container app
    public WEBCAM_DISPLAY_HEIGHT: any; // = 'auto';

    @ViewChild('video')
    public video?: ElementRef<HTMLVideoElement>;
    @ViewChild('canvas')
    // @Output() getPicture = new EventEmitter<WebcamImage>();
    public canvas?: ElementRef;
    isCameraExist = true;
    public CameraCount: number = 0;
    private trigger: Subject<void> = new Subject<void>();
    private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
    showWebcam = true;
    errors: WebcamInitError[] = [];
    find = false;
    search = false;
    isForPompe?: boolean;

    refreshIntervalId!: NodeJS.Timeout;
    alterMsgId!: NodeJS.Timeout;

    constructor(
        private route: ActivatedRoute,
        private coreData: CoreData,
        private snackBar: MatSnackBar,
        private location: Location) { }



    ngOnInit(): void {
        this.isForPompe = JSON.parse(this.route.snapshot.params?.['isForPompe']);

        this.WEBCAM_DISPLAY_HEIGHT = window.innerHeight - 100;
        this.WEBCAM_DISPLAY_WIDTH = window.innerWidth - 30;
        this.initCamera();
    }

    ngAfterViewInit(): void {
        this.takeSnapshot()
    }

    ngOnDestroy(): void {
        clearInterval(this.refreshIntervalId)
        clearInterval(this.alterMsgId)
    }

    public get videoOptions(): MediaTrackConstraints {

        //you can set ideal,min,max for width and height
        const result: MediaTrackConstraints = {
            width: { min: 640, ideal: 1920 },
            height: { min: 480, ideal: 1080 },
            facingMode: { ideal: 'environment' }
        };

        return result;
    }

    initCamera() {

        WebcamUtil.getAvailableVideoInputs()
            .then((mediaDevices: MediaDeviceInfo[]) => {
                this.isCameraExist = mediaDevices && mediaDevices.length > 0;
            });
    }

    getCameraCount() {

        WebcamUtil.getAvailableVideoInputs()
            .then((mediaDevices: MediaDeviceInfo[]) => {
                this.CameraCount = mediaDevices && mediaDevices.length;
            });
    }

    changeWebCame(directionOrDeviceId: boolean | string) {
        this.nextWebcam.next(directionOrDeviceId);
    }

    takeSnapshot(): void {
        this.search = !this.search;
        if (this.search) {

            this.refreshIntervalId = setInterval(() => {
                if (!this.find && this.search) {
                    this.trigger.next();
                }
            }, 100)

            this.alterMsgId = setInterval(() => {
                NotificationManager.handleWarning('Impossible de lire le QR Code. Veuillez placer le QR Code au centre', this.snackBar);
            }, 5000)
        }
    }
    handleImage(webcamImage: WebcamImage) {
        this.tick(webcamImage.imageData);
    }

    get triggerObservable(): Observable<void> {
        return this.trigger.asObservable();
    }

    get nextWebcamObservable(): Observable<boolean | string> {
        return this.nextWebcam.asObservable();
    }

    tick(imageData: ImageData) {
        const code: QRCode = jsQR(this.thresholdFilter(imageData.data), imageData.width, imageData.height, {
            inversionAttempts: "dontInvert",
        })!;
        if (code) {
            NotificationManager.handleSuccess(`${code.data}`, this.snackBar);
            this.find = true;
            this.isForPompe ? this.coreData.ScannedPompeCode = code.data : this.coreData.ScannedCassetteCode = code.data.split('-')[2];
            this.navigateBack();
        }
        else {
            NotificationManager.handleWarning('Impossible de lire le QR Code. Veuillez placer le QR Code au centre', this.snackBar);
        }
    }

    thresholdFilter(pixels: Uint8ClampedArray, level?: number) {
        if (level === undefined) {
            level = 0.9;
        }
        const thresh = Math.floor(level * 255);
        for (let i = 0; i < pixels.length; i += 4) {
            const r = pixels[i];
            const g = pixels[i + 1];
            const b = pixels[i + 2];
            const gray = 0.2126 * r + 0.7152 * g + 0.0722 * b;
            let val;
            if (gray >= thresh) {
                val = 255;
            } else {
                val = 0;
            }
            pixels[i] = pixels[i + 1] = pixels[i + 2] = val;
        }
        return pixels;
    }

    navigateBack(): void {
        this.location.back()
    }
}
